import Manager from 'coreClasses/Manager';

const ERRORS_CONFIG = {
	default: {
		threshold: 0,
		timeFrameInSeconds: 60
	}
};

/**
 * Represents ErrorsStreamMgr
 */
class ErrorsStreamMgr extends Manager {
	private map: Map<string, any> = new Map();
	private resetTimeouts = {};

	/**
	 * Notify all listeners about updates
	 * the update is triggered only once per timeFrameInSeconds
	 * and when the configured threshold is passed
	 * @param {string} updateID - update id
	 * @param {object} data - data
	 */
	async notify(updateID: string, data: object = {}): Promise<void> {
		const now = Date.now();
		const config = updateID in ERRORS_CONFIG ? ERRORS_CONFIG[updateID] : ERRORS_CONFIG.default;
		const timeFrameInMs = config.timeFrameInSeconds * 1000;

		let record;

		if (this.map.has(updateID)) {
			record = this.map.get(updateID);
			record.occurrences = record.occurrences + 1;
		} else {
			record = {
				occurrences: 1,
				fired: null
			};
		}

		clearTimeout(this.resetTimeouts[updateID]);

		if (
			record.occurrences > config.threshold
			&& (
				!record.fired
				|| (record.fired + timeFrameInMs) < now
			)
		) {
			record.fired = now;
			record.occurrences = 0;

			this.resetTimeouts[updateID] = setTimeout(() => {
				record.occurrences = 0;
				record.fired = null;
			}, timeFrameInMs);

			await super.notify(updateID, data);
		} else {
			this.resetTimeouts[updateID] = setTimeout(() => {
				record.occurrences = 0;
				record.fired = null;
			}, timeFrameInMs);
		}

		this.map.set(updateID, record);
	}
}

export default ErrorsStreamMgr;
